import Group from 'components/utils/Group'
import type { PropsWithChildren } from 'react'
import styled from 'styled-components'

export const AccommodationIndividualSelectRoomOptionTileCTAContainer = styled(Group)`
  position: relative;
`

function AccommodationIndividualSelectRoomOptionTileCTA(props: PropsWithChildren) {
  return <AccommodationIndividualSelectRoomOptionTileCTAContainer
    {...props}
    direction="vertical"
    verticalAlign="end"
    gap={12}
  />
}

export default AccommodationIndividualSelectRoomOptionTileCTA
